/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaxCheckAddAddressRequest,
  PaxCheckAddAddressResponse,
  PaxCheckApplyManualDocumentRequest,
  PaxCheckApplyManualDocumentResponse,
  PaxCheckApplyRecognisedDocumentRequest,
  PaxCheckApplyRecognisedDocumentResponse,
  PaxCheckApplyTravelDocumentRequest,
  PaxCheckApplyTravelDocumentResponse,
  PaxCheckGetPaxSessionResponse,
  PaxCheckGetSessionResponse,
  PaxCheckRecogniseDocumentResponse,
  PaxCheckSetAnswersRequest,
  PaxCheckSetAnswersResponse,
  PaxCheckSetConsentRequest,
  PaxCheckSetConsentResponse,
  PaxCheckStart1Response,
  PaxCheckStartWithBookingIdAndSurnameRequest,
  PaxCheckStartWithBookingIdAndSurnameResponse,
} from '../models/index';
import {
    PaxCheckAddAddressRequestFromJSON,
    PaxCheckAddAddressRequestToJSON,
    PaxCheckAddAddressResponseFromJSON,
    PaxCheckAddAddressResponseToJSON,
    PaxCheckApplyRecognisedDocumentRequestFromJSON,
    PaxCheckApplyRecognisedDocumentRequestToJSON,
    PaxCheckApplyRecognisedDocumentResponseFromJSON,
    PaxCheckApplyRecognisedDocumentResponseToJSON,
    PaxCheckApplyManualDocumentRequestToJSON,
    PaxCheckApplyManualDocumentResponseFromJSON,
    PaxCheckApplyTravelDocumentRequestFromJSON,
    PaxCheckApplyTravelDocumentRequestToJSON,
    PaxCheckApplyTravelDocumentResponseFromJSON,
    PaxCheckApplyTravelDocumentResponseToJSON,
    PaxCheckGetPaxSessionResponseFromJSON,
    PaxCheckGetPaxSessionResponseToJSON,
    PaxCheckGetSessionResponseFromJSON,
    PaxCheckGetSessionResponseToJSON,
    PaxCheckRecogniseDocumentResponseFromJSON,
    PaxCheckRecogniseDocumentResponseToJSON,
    PaxCheckSetAnswersRequestFromJSON,
    PaxCheckSetAnswersRequestToJSON,
    PaxCheckSetAnswersResponseFromJSON,
    PaxCheckSetAnswersResponseToJSON,
    PaxCheckSetConsentRequestFromJSON,
    PaxCheckSetConsentRequestToJSON,
    PaxCheckSetConsentResponseFromJSON,
    PaxCheckSetConsentResponseToJSON,
    PaxCheckStart1ResponseFromJSON,
    PaxCheckStart1ResponseToJSON,
    PaxCheckStartWithBookingIdAndSurnameRequestFromJSON,
    PaxCheckStartWithBookingIdAndSurnameRequestToJSON,
    PaxCheckStartWithBookingIdAndSurnameResponseFromJSON,
    PaxCheckStartWithBookingIdAndSurnameResponseToJSON,
} from '../models/index';

export interface AddAddressRequest {
    sessionId: string;
    paxSessionId: string;
    paxCheckAddAddressRequest: PaxCheckAddAddressRequest;
    xRequestId?: string;
    acceptLanguage?: string;
}

export interface ApplyRecognisedDocumentRequest {
    sessionId: string;
    paxSessionId: string;
    paxCheckApplyRecognisedDocumentRequest: PaxCheckApplyRecognisedDocumentRequest;
    xRequestId?: string;
    acceptLanguage?: string;
}

export interface ApplyTravelDocumentRequest {
    sessionId: string;
    paxSessionId: string;
    paxCheckApplyTravelDocumentRequest: PaxCheckApplyTravelDocumentRequest;
    xRequestId?: string;
    acceptLanguage?: string;
}

export interface ApplyManualDocumentRequest {
    sessionId: string;
    paxSessionId: string;
    paxCheckApplyManualDocumentRequest: PaxCheckApplyManualDocumentRequest;
    xRequestId?: string;
    acceptLanguage?: string;
}

export interface GetPaxSessionRequest {
    sessionId: string;
    paxSessionId: string;
    xRequestId?: string;
    acceptLanguage?: string;
}

export interface GetSessionRequest {
    sessionId: string;
    xRequestId?: string;
    acceptLanguage?: string;
}

export interface PostAnswersRequest {
    sessionId: string;
    paxSessionId: string;
    paxCheckSetAnswersRequest: PaxCheckSetAnswersRequest;
    xRequestId?: string;
    acceptLanguage?: string;
}

export interface RecogniseDocumentRequest {
    sessionId: string;
    paxSessionId: string;
    xRequestId?: string;
    method?: string;
    expectedDocumentTypes?: Array<string>;
    pageIndexToProcess?: number;
    files?: Array<Blob>;
}

export interface SetConsentRequest {
    sessionId: string;
    paxCheckSetConsentRequest: PaxCheckSetConsentRequest;
    xRequestId?: string;
    acceptLanguage?: string;
}

export interface Start2GetRequest {
    encryptedBookingId: string;
    redirectUrl: string;
    xRequestId?: string;
    returnUrl?: string;
    paxIds?: string;
    consented?: string;
    locale?: string;
    departureStation?: string;
    encryptionMode?: string;
}

export interface StartGetRequest {
    encryptedBookingId: string;
    xRequestId?: string;
    consented?: string;
    paxIds?: string;
    encryptionMode?: string;
}

export interface StartWithBookingIdAndSurnamePostRequest {
    paxCheckStartWithBookingIdAndSurnameRequest: PaxCheckStartWithBookingIdAndSurnameRequest;
    xRequestId?: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Add address to pax session
     */
    async addAddressRaw(requestParameters: AddAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckAddAddressResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling addAddress().'
            );
        }

        if (requestParameters['paxSessionId'] == null) {
            throw new runtime.RequiredError(
                'paxSessionId',
                'Required parameter "paxSessionId" was null or undefined when calling addAddress().'
            );
        }

        if (requestParameters['paxCheckAddAddressRequest'] == null) {
            throw new runtime.RequiredError(
                'paxCheckAddAddressRequest',
                'Required parameter "paxCheckAddAddressRequest" was null or undefined when calling addAddress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/session/{sessionId}/pax-session/{paxSessionId}/address`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId']))).replace(`{${"paxSessionId"}}`, encodeURIComponent(String(requestParameters['paxSessionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaxCheckAddAddressRequestToJSON(requestParameters['paxCheckAddAddressRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckAddAddressResponseFromJSON(jsonValue));
    }

    /**
     * Add address to pax session
     */
    async addAddress(requestParameters: AddAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckAddAddressResponse> {
        const response = await this.addAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Apply document recognised by /recognise-document
     */
    async applyRecognisedDocumentRaw(requestParameters: ApplyRecognisedDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckApplyRecognisedDocumentResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling applyRecognisedDocument().'
            );
        }

        if (requestParameters['paxSessionId'] == null) {
            throw new runtime.RequiredError(
                'paxSessionId',
                'Required parameter "paxSessionId" was null or undefined when calling applyRecognisedDocument().'
            );
        }

        if (requestParameters['paxCheckApplyRecognisedDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'paxCheckApplyRecognisedDocumentRequest',
                'Required parameter "paxCheckApplyRecognisedDocumentRequest" was null or undefined when calling applyRecognisedDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/session/{sessionId}/pax-session/{paxSessionId}/apply-document/recognised`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId']))).replace(`{${"paxSessionId"}}`, encodeURIComponent(String(requestParameters['paxSessionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaxCheckApplyRecognisedDocumentRequestToJSON(requestParameters['paxCheckApplyRecognisedDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckApplyRecognisedDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Apply document recognised by /recognise-document
     */
    async applyRecognisedDocument(requestParameters: ApplyRecognisedDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckApplyRecognisedDocumentResponse> {
        const response = await this.applyRecognisedDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Apply manually provided travel document data
     */
    async applyTravelDocumentRaw(requestParameters: ApplyTravelDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckApplyTravelDocumentResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling applyTravelDocument().'
            );
        }

        if (requestParameters['paxSessionId'] == null) {
            throw new runtime.RequiredError(
                'paxSessionId',
                'Required parameter "paxSessionId" was null or undefined when calling applyTravelDocument().'
            );
        }

        if (requestParameters['paxCheckApplyTravelDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'paxCheckApplyTravelDocumentRequest',
                'Required parameter "paxCheckApplyTravelDocumentRequest" was null or undefined when calling applyTravelDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/session/{sessionId}/pax-session/{paxSessionId}/apply-document/travel-document`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId']))).replace(`{${"paxSessionId"}}`, encodeURIComponent(String(requestParameters['paxSessionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaxCheckApplyTravelDocumentRequestToJSON(requestParameters['paxCheckApplyTravelDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckApplyTravelDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Apply manually provided travel document data
     */
    async applyTravelDocument(requestParameters: ApplyTravelDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckApplyTravelDocumentResponse> {
        const response = await this.applyTravelDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Apply manually provided non-travel document data (e.g. onward ticket)
     */
    async applyManualDocumentRaw(requestParameters: ApplyManualDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckApplyManualDocumentResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError('sessionId', 'Required parameter "sessionId" was null or undefined when calling applyManualDocument().');
        }
        if (requestParameters['paxSessionId'] == null) {
            throw new runtime.RequiredError('paxSessionId', 'Required parameter "paxSessionId" was null or undefined when calling applyManualDocument().');
        }
        if (requestParameters['paxCheckApplyManualDocumentRequest'] == null) {
            throw new runtime.RequiredError('paxCheckApplyManualDocumentRequest', 'Required parameter "paxCheckApplyManualDocumentRequest" was null or undefined when calling applyManualDocument().');
        }

        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }
        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        const response = await this.request({
            path: `/session/{sessionId}/pax-session/{paxSessionId}/apply-document/manual`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])))
                .replace(`{${"paxSessionId"}}`, encodeURIComponent(String(requestParameters['paxSessionId']))),
            method: 'POST',
            headers: headerParameters,
            query: {},
            body: PaxCheckApplyManualDocumentRequestToJSON(requestParameters['paxCheckApplyManualDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckApplyManualDocumentResponseFromJSON(jsonValue));
    }

    async applyManualDocument(requestParameters: ApplyManualDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckApplyManualDocumentResponse> {
        const response = await this.applyManualDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Pax session
     */
    async getPaxSessionRaw(requestParameters: GetPaxSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckGetPaxSessionResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getPaxSession().'
            );
        }

        if (requestParameters['paxSessionId'] == null) {
            throw new runtime.RequiredError(
                'paxSessionId',
                'Required parameter "paxSessionId" was null or undefined when calling getPaxSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/session/{sessionId}/pax-session/{paxSessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId']))).replace(`{${"paxSessionId"}}`, encodeURIComponent(String(requestParameters['paxSessionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckGetPaxSessionResponseFromJSON(jsonValue));
    }

    /**
     * Get Pax session
     */
    async getPaxSession(requestParameters: GetPaxSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckGetPaxSessionResponse> {
        const response = await this.getPaxSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get MultiPax session
     */
    async getSessionRaw(requestParameters: GetSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckGetSessionResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/session/{sessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckGetSessionResponseFromJSON(jsonValue));
    }

    /**
     * Get MultiPax session
     */
    async getSession(requestParameters: GetSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckGetSessionResponse> {
        const response = await this.getSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Provide nationality and/or birthdate and/or set answers to questions
     */
    async postAnswersRaw(requestParameters: PostAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckSetAnswersResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling postAnswers().'
            );
        }

        if (requestParameters['paxSessionId'] == null) {
            throw new runtime.RequiredError(
                'paxSessionId',
                'Required parameter "paxSessionId" was null or undefined when calling postAnswers().'
            );
        }

        if (requestParameters['paxCheckSetAnswersRequest'] == null) {
            throw new runtime.RequiredError(
                'paxCheckSetAnswersRequest',
                'Required parameter "paxCheckSetAnswersRequest" was null or undefined when calling postAnswers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/session/{sessionId}/pax-session/{paxSessionId}/answers`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId']))).replace(`{${"paxSessionId"}}`, encodeURIComponent(String(requestParameters['paxSessionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaxCheckSetAnswersRequestToJSON(requestParameters['paxCheckSetAnswersRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckSetAnswersResponseFromJSON(jsonValue));
    }

    /**
     * Provide nationality and/or birthdate and/or set answers to questions
     */
    async postAnswers(requestParameters: PostAnswersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckSetAnswersResponse> {
        const response = await this.postAnswersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recognise document (photo, scan or PDF)
     */
    async recogniseDocumentRaw(requestParameters: RecogniseDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckRecogniseDocumentResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling recogniseDocument().'
            );
        }

        if (requestParameters['paxSessionId'] == null) {
            throw new runtime.RequiredError(
                'paxSessionId',
                'Required parameter "paxSessionId" was null or undefined when calling recogniseDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['method'] != null) {
            formParams.append('method', requestParameters['method'] as any);
        }

        if (requestParameters['expectedDocumentTypes'] != null) {
            formParams.append('expected_document_types', requestParameters['expectedDocumentTypes']!.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        if (requestParameters['pageIndexToProcess'] != null) {
            formParams.append('page_index_to_process', requestParameters['pageIndexToProcess'] as any);
        }

        if (requestParameters['files'] != null) {
            requestParameters['files'].forEach((element) => {
                formParams.append('files', element as any);
            })
        }

        const response = await this.request({
            path: `/session/{sessionId}/pax-session/{paxSessionId}/recognise-document`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId']))).replace(`{${"paxSessionId"}}`, encodeURIComponent(String(requestParameters['paxSessionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckRecogniseDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Recognise document (photo, scan or PDF)
     */
    async recogniseDocument(requestParameters: RecogniseDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckRecogniseDocumentResponse> {
        const response = await this.recogniseDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set consent for MultiPax session
     */
    async setConsentRaw(requestParameters: SetConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckSetConsentResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling setConsent().'
            );
        }

        if (requestParameters['paxCheckSetConsentRequest'] == null) {
            throw new runtime.RequiredError(
                'paxCheckSetConsentRequest',
                'Required parameter "paxCheckSetConsentRequest" was null or undefined when calling setConsent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/session/{sessionId}/set-consent`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaxCheckSetConsentRequestToJSON(requestParameters['paxCheckSetConsentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckSetConsentResponseFromJSON(jsonValue));
    }

    /**
     * Set consent for MultiPax session
     */
    async setConsent(requestParameters: SetConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckSetConsentResponse> {
        const response = await this.setConsentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * For in-browser redirect — initiate MultiPax session with encrypted booking id, redirect browser to URL with session token to authorize further requests
     */
    async start2GetRaw(requestParameters: Start2GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['encryptedBookingId'] == null) {
            throw new runtime.RequiredError(
                'encryptedBookingId',
                'Required parameter "encryptedBookingId" was null or undefined when calling start2Get().'
            );
        }

        if (requestParameters['redirectUrl'] == null) {
            throw new runtime.RequiredError(
                'redirectUrl',
                'Required parameter "redirectUrl" was null or undefined when calling start2Get().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['encryptedBookingId'] != null) {
            queryParameters['encrypted_booking_id'] = requestParameters['encryptedBookingId'];
        }

        if (requestParameters['redirectUrl'] != null) {
            queryParameters['redirect_url'] = requestParameters['redirectUrl'];
        }

        if (requestParameters['returnUrl'] != null) {
            queryParameters['return_url'] = requestParameters['returnUrl'];
        }

        if (requestParameters['paxIds'] != null) {
            queryParameters['pax_ids'] = requestParameters['paxIds'];
        }

        if (requestParameters['consented'] != null) {
            queryParameters['consented'] = requestParameters['consented'];
        }

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        if (requestParameters['departureStation'] != null) {
            queryParameters['departure_station'] = requestParameters['departureStation'];
        }

        if (requestParameters['encryptionMode'] != null) {
            queryParameters['encryption_mode'] = requestParameters['encryptionMode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        const response = await this.request({
            path: `/start2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * For in-browser redirect — initiate MultiPax session with encrypted booking id, redirect browser to URL with session token to authorize further requests
     */
    async start2Get(requestParameters: Start2GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.start2GetRaw(requestParameters, initOverrides);
    }

    /**
     * Initiate MultiPax session with encrypted booking id, get session token to authorize further requests
     */
    async startGetRaw(requestParameters: StartGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckStart1Response>> {
        if (requestParameters['encryptedBookingId'] == null) {
            throw new runtime.RequiredError(
                'encryptedBookingId',
                'Required parameter "encryptedBookingId" was null or undefined when calling startGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['encryptedBookingId'] != null) {
            queryParameters['encrypted_booking_id'] = requestParameters['encryptedBookingId'];
        }

        if (requestParameters['consented'] != null) {
            queryParameters['consented'] = requestParameters['consented'];
        }

        if (requestParameters['paxIds'] != null) {
            queryParameters['pax_ids'] = requestParameters['paxIds'];
        }

        if (requestParameters['encryptionMode'] != null) {
            queryParameters['encryption_mode'] = requestParameters['encryptionMode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        const response = await this.request({
            path: `/start`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckStart1ResponseFromJSON(jsonValue));
    }

    /**
     * Initiate MultiPax session with encrypted booking id, get session token to authorize further requests
     */
    async startGet(requestParameters: StartGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckStart1Response> {
        const response = await this.startGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiate MultiPax session with booking id and surname
     */
    async startWithBookingIdAndSurnamePostRaw(requestParameters: StartWithBookingIdAndSurnamePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaxCheckStartWithBookingIdAndSurnameResponse>> {
        if (requestParameters['paxCheckStartWithBookingIdAndSurnameRequest'] == null) {
            throw new runtime.RequiredError(
                'paxCheckStartWithBookingIdAndSurnameRequest',
                'Required parameter "paxCheckStartWithBookingIdAndSurnameRequest" was null or undefined when calling startWithBookingIdAndSurnamePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestId'] != null) {
            headerParameters['X-Request-Id'] = String(requestParameters['xRequestId']);
        }

        const response = await this.request({
            path: `/start-with-booking-id-and-surname`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaxCheckStartWithBookingIdAndSurnameRequestToJSON(requestParameters['paxCheckStartWithBookingIdAndSurnameRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaxCheckStartWithBookingIdAndSurnameResponseFromJSON(jsonValue));
    }

    /**
     * Initiate MultiPax session with booking id and surname
     */
    async startWithBookingIdAndSurnamePost(requestParameters: StartWithBookingIdAndSurnamePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaxCheckStartWithBookingIdAndSurnameResponse> {
        const response = await this.startWithBookingIdAndSurnamePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
